import { Nullable } from '../Nullable/index.js';
export const Less = -1;
export const Equal = 0;
export const Greater = 1;
//#endregion
/**
 * @deprecated use Order module instead
 */
export const defaultCompare = (left, right) => {
    if (left > right) {
        return 1;
    }
    if (left < right) {
        return -1;
    }
    // Date can't be compared with == & ===
    return 0;
};
export function compareNullable(...args) {
    if (args.length === 2) {
        return compareNullableIntertnal(defaultCompare)(...args);
    }
    const [compare] = args;
    return compareNullableIntertnal(compare);
}
const compareNullableIntertnal = (compare) => (left, right) => {
    if (Nullable.isNonNullable(left) && Nullable.isNonNullable(right)) {
        return compare(left, right);
    }
    return Nullable.isNonNullable(left) ? 1 : -1;
};
export function compareBy(getProperty, compare) {
    return (left, right) => {
        const leftProp = getProperty(left);
        const rightProp = getProperty(right);
        return compare
            ? compare(leftProp, rightProp)
            : defaultCompare(leftProp, rightProp);
    };
}
/**
 * Reverses compare
 * @param compare Target comparison
 * @example
 * type User = {age: number}
 * const getAge = (user: User) => user.age
 * const compareByAge = compareBy(getAge)
 * const compareByAgeDescending = reverse(compareByAge)
 * @deprecated use Order module instead
 */
export const reverse = (compare) => (left, right) => compare(right, left);
/**
 * Combines compare function in left-to-right order
 * @example
 * type User = {rating: number, age: number}
 *
 * const compareByAge = compareBy(getAge);
 * const compareByRating = compareBy(getRating);
 * const compareByAgeThenRating = combine(compareByAge, compareByRating);
 * @deprecated use Order module instead
 */
export const combine = (...compares) => (left, right) => {
    for (const compare of compares) {
        const result = compare(left, right);
        if (result !== 0) {
            return result;
        }
    }
    return 0;
};
/**
 *
 * @example
 * const RAT_ORDER = ['2g', '3g', '4g'];
 * const compareRats = fromOrder(RAT_ORDER);
 *
 * const sortedRats = sortWith(compareRats)(['3g', '4g', '2g'])
 * @deprecated use Order module instead
 */
export const fromOrder = (order) => (left, right) => Math.min(Math.max(order.indexOf(left) - order.indexOf(right), -1), 1);
/**
 * @deprecated use Order module instead
 */
export const max = (compare) => (left, right) => compare(left, right) > 0 ? left : right;
/**
 * @deprecated use Order module instead
 */
export const min = (compare) => (left, right) => compare(left, right) < 0 ? left : right;
/**
 * @deprecated use Order module instead
 */
export const gt = (compare) => (left, right) => compare(left, right) > 0;
/**
 * @deprecated use Order module instead
 */
export const gte = (compare) => (left, right) => compare(left, right) >= 0;
/**
 * @deprecated use Order module instead
 */
export const lt = (compare) => (left, right) => compare(left, right) < 0;
/**
 * @deprecated use Order module instead
 */
export const lte = (compare) => (left, right) => compare(left, right) <= 0;
/**
 * @deprecated use `BigNumber.order` instead
 */
export const cmpBigNumber = (left, right) => {
    if (left.eq(right)) {
        return 0;
    }
    return left.gt(right) ? 1 : -1;
};
//# sourceMappingURL=Cmp.js.map